module.exports = __webpack_public_path__ + "img/course_noteBack.44313042.png";